module.exports = __webpack_public_path__ + "media/toxis-horizontal.109af51e.mp4";